import { Contacts } from '~/components/Contacts/Contacts'

export default function ContactsPage() {
  return <Contacts />
}